export interface StrategyParametersComponentState {
    quickSearchText: string;
}

export const initialStrategyParametersComponentState: StrategyParametersComponentState =
    {
        quickSearchText: '',
    };
